
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSaasBillPayments"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSaasBillPayments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invoice_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saas_payment_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"base_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vat_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vat_rate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payment_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_month"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_cycle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_period_start"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_period_end"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_subscription_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_subscriptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_subscriptions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_amount_per_subscription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additional_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bill_generated_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paid_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"arrears_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"arrears_invoice_ids"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"carried_into_invoice_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"settled_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":680}};
    doc.loc.source = {"body":"query getSaasBillPayments {\n  getSaasBillPayments {\n    totalCount\n    items {\n      _id\n      invoice_id\n      saas_payment_id\n      amount\n      base_amount\n      vat_amount\n      vat_rate\n      payment_type\n      status\n      billing_month\n      billing_year\n      billing_cycle\n      billing_period_start\n      billing_period_end\n      customer_subscription_count\n      min_subscriptions\n      min_amount\n      additional_subscriptions\n      additional_amount_per_subscription\n      additional_amount\n      bill_generated_at\n      paid_at\n      currency\n      arrears_amount\n      arrears_invoice_ids\n      carried_into_invoice_id\n      settled_at\n      createdAt\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getSaasBillPayments"] = oneQuery(doc, "getSaasBillPayments");
        
